<script>
   /*************************************************************/
   /* Widget for spike removal                                   */
   /* -----------------------------------                       */
   /*************************************************************/

   import { Container, RangeDiscrete } from 'svelte-controls-basic';
   import PrepTemplate from './PrepTemplate.svelte';

   let {
      params = $bindable([5, 5]),
      settings = $bindable(),
      ...others
   } = $props();

   // prefix for the label ids the controls below are named by, unique per widget instance
   const uid = $props.id();


   // initial settings
   const title = 'Spike removal';

   $effect(() => {
      settings = params[0] + '/' + params[1];
   });
</script>


<PrepTemplate {title} {settings} {...others}>
   <Container label="Window" id="{uid}-window">
   <RangeDiscrete bind:value={params[0]} min={3} max={15} step={2} />
   </Container>
   <Container label="Threshold" id="{uid}-threshold">
   <RangeDiscrete bind:value={params[1]} min={3} max={50} />
   </Container>
</PrepTemplate>

